import firebase from 'firebase'
const firebaseConfig = {
    apiKey: "AIzaSyB0ikA2ZyHmCzk__oa13_ZzEtQIvSwrBig",
    authDomain: "privatehomeservice2020.firebaseapp.com",
    databaseURL: "https://privatehomeservice2020.firebaseio.com",
    projectId: "privatehomeservice2020",
    storageBucket: "privatehomeservice2020.appspot.com",
    messagingSenderId: "814238575534",
    appId: "1:814238575534:web:435650bec93687a1fdf63f",
    measurementId: "G-ZG5F0VFVBZ"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default firebase